// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import { updateBulkEditState } from 'redux/modules/bulkEdit/actions'
import getVisibleSegmentEndIds from 'redux/modules/bulkEdit/thunks/getVisibleSegmentEndIds'

const toggleAllVisibleSites = () => (dispatch, getState) => {
  const { bulkEdit } = getState()

  const highlightedSiteIds = bulkEdit.get('highlightedSiteIds')
  const visiblePathIds = bulkEdit.get('visiblePathIds')

  // since there are two sites per path, we can check to see if
  // the highlighted sites size is twice as large as the visible paths size.
  if ((highlightedSiteIds.size / 2) === visiblePathIds.size) {
    return dispatch(updateBulkEditState({
      highlightedSiteIds: highlightedSiteIds.clear(),
    }))
  }

  // collect all the visible sites' ids
  const allVisibleSiteIds = dispatch(getVisibleSegmentEndIds())

  return dispatch(updateBulkEditState({
    highlightedSiteIds: fromJS(allVisibleSiteIds),
  }))
}

export default toggleAllVisibleSites
